import $ from 'jquery';
import {onResize, onScroll} from "../utils/window";
import _ from 'lodash';

/* TODO: DELETE OLD MEGA CODE */

export default function headerSection() {
	const $html = $('html');
	const $header = $('#header');
	const $headerMain = $('#header-main');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const buffers = $('.header-buffer');
	const newMegaItems = $('.header-newmega-li.-parent');
	const megaItems = $('.header-mega-li.-parent, .header-mega-li.-normal-parent');

	if (headerToggler) {
		headerToggler.on('toggle', function () {
			$html.toggleClass('is-header-open', headerToggler.isOpen);
		});
	}

	function setupHeaderBuffer() {
		buffers.each(function () {
			const _this = $(this);
			const bufferEl = _this.find('> .header-buffer_el');
			let $heightEl = $header;

			if ($header.hasClass('is-stuck') || $header.hasClass('is-scrolling')) {
				$heightEl = $header.next();
			}

			if (bufferEl.length) {
				bufferEl.css('height', $heightEl.outerHeight() + 'px');
			} else {
				_this.prepend('<div class="header-buffer_el" style="' + $heightEl.outerHeight() + 'px"></div>');
			}
		})
	}

	function setupMegaHover() {
		newMegaItems.on('mouseenter', _.debounce(function () {
			const _this = $(this);
			$header.addClass('is-mega-open');
		}, 100));
		newMegaItems.on('mouseleave', _.debounce(function () {
			const _this = $(this);
			$header.removeClass('is-mega-open');
		}, 100));
		megaItems.on('mouseenter', _.debounce(function () {
			const _this = $(this);
			$header.addClass('is-mega-open');
		}, 100));
		megaItems.on('mouseleave', _.debounce(function () {
			const _this = $(this);
			$header.removeClass('is-mega-open');
		}, 100));
	}

	function refreshMegaMenuBuffer() {
		newMegaItems.each(function () {
			const _this = $(this);
			const $buffer = _this.find('> .header-buffer');

			if ($buffer.length) {
				const $bufferEl = $buffer.find('> .header-buffer_el');
				$bufferEl.css('height', $headerMain.outerHeight() + 'px');
			}
		});

		megaItems.each(function () {
			const _this = $(this);
			const $buffer = _this.find('> .header-buffer');

			if ($buffer.length) {
				const $bufferEl = $buffer.find('> .header-buffer_el');
				$bufferEl.css('height', $headerMain.outerHeight() + 'px');
			}
		});
	}

	function setupMobileMenu() {
		const link = $('a.mobile-menu-item_link.has-children, a.mobile-newmenu-item_link.has-children');
		const backs = $('.mobile-menu-sub_back, .mobile-newmenu-sub_back');

		link.on('click', function (e) {
			e.preventDefault();

			const _this = $(this);
			const subMenu = _this.next();

			subMenu.addClass('is-opened');
		});

		backs.on('click', function (e) {
			const $parent = $(this).parent();

			$parent.removeClass('is-opened');
		});
	}

	function setupMegaImages() {
		const links = $header.find('.header-mega-sec-links > li > a[data-id], .header-mega-sec-content a[data-id]');
		const images = $header.find('.header-mega-sec-media .header-mega-sec-media-imgs > .media');

		if (links.length && images.length) {
			links.on('mouseenter', function () {
				const $this = $(this);
				images.removeClass('-show');
				$(`.media[data-entry=${$this.data('id')}]`).addClass('-show');
			});
		}
	}

	newMegaItems.each((_, megaItem) => {
		const leftTriggers = megaItem.querySelectorAll('.header-newmega-left-items > li > [data-section-trigger]');
		const rightContainer = megaItem.querySelector('.header-newmega-right');
		const rightSections = Array.from(megaItem.querySelectorAll('.header-newmega-right-section'));

		// Set up switching between sections
		leftTriggers.forEach((leftTrigger) => {
			leftTrigger.addEventListener('click', (event) => {
				leftTriggers.forEach((otherLeftTrigger) => {
					otherLeftTrigger.classList.remove('is-selected');
				});
				leftTrigger.classList.add('is-selected');
				rightSections.forEach((rightSection) => {
					if (rightSection.getAttribute('data-section') === leftTrigger.getAttribute('data-section-trigger')) {
						rightSection.classList.add('is-selected');
						event.preventDefault();
					} else {
						rightSection.classList.remove('is-selected');
					}
				});
			});
		});

		// Set min height on right half of menu
		const setMinHeight = () => {
			const heights = rightSections.map(
				(section) => Array.from(section.children)
					.reduce((acc, child) => acc + child.clientHeight, 0)
			);
			const minHeight = Math.max(...heights);
			rightContainer.style.minHeight = `${minHeight}px`;
		}
		setMinHeight();
		window.addEventListener('resize', setMinHeight);
	});

	setupMobileMenu();
	setupHeaderBuffer();
	onResize(setupHeaderBuffer);
	setupMegaHover();
	setupMegaImages();

	let lastScrollTop = 0;
	let firstScroll = true;
	const headerHeight = $header.outerHeight();

	onScroll(function (e) {
		let st = $(window).scrollTop();
		if (st > lastScrollTop) {
			// downscroll code
			if ($header.hasClass('is-stuck')) {
				if (firstScroll) {
					$header.addClass('-initial');
					firstScroll = false;

					refreshMegaMenuBuffer();

					setTimeout(function () {
						$header.removeClass('-initial');
					}, 300);
				}
				$header.addClass('is-scrolling');

			} else {
				$header.removeClass('is-scrolling');
			}
		} else {
			// up scroll code
			$header.removeClass('is-scrolling');

			if (!$header.hasClass('is-stuck')) {
				firstScroll = true;
				$header.removeClass('-initial');

				refreshMegaMenuBuffer();
			}
		}
		lastScrollTop = st;
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js